import React from "react";
import { Link } from "react-router-dom";

export default function CommonBreadCum(props) {
  const pageName = props.pageName ? props.pageName : "52-week-high";
  return (
    <div className="customNav">
      <div
        className={
          pageName === "52-week-high" ? "shadowBox active" : "shadowBox"
        }
      >
        <Link to={"/52-week-high-stocks"}>
          <i className="fa fa-plus-circle  mr-2"></i>
          52 Week High
        </Link>
      </div>
      <div
        className={
          pageName === "52-week-low" ? "shadowBox active" : "shadowBox"
        }
      >
        <Link to={"/52-week-low-stocks"}>
          <i className="fa fa-minus-circle mr-2"></i> 52 Week Low
        </Link>
      </div>
      <div
        className={
          pageName === "top-gainers" ? "shadowBox active" : "shadowBox"
        }
      >
        <Link to={"/top-gainers-nse"}>
          <i className="fa fa-arrow-circle-up  mr-2"></i>Top Gainers
        </Link>
      </div>
      <div
        className={pageName === "top-losers" ? "shadowBox active" : "shadowBox"}
      >
        <Link to={"/top-losers-nse"}>
          <i className="fa fa-arrow-circle-down  mr-2"></i>Top Losers
        </Link>
      </div>
      <div
        className={
          pageName === "all-time-high" ? "shadowBox active" : "shadowBox"
        }
      >
        <Link to={"/market/all-time-high-stocks"}>
          <i className="fa fa-info-circle  mr-2"></i>All Time High
        </Link>
      </div>
      <div
        className={
          pageName === "delivery-breakout" ? "shadowBox active" : "shadowBox"
        }
      >
        <Link to={"/breakout-stocks"}>
          <i className="fa fa-info-circle  mr-2"></i>Delivery Breakout
        </Link>
      </div>
    </div>
  );
}
